import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useQuery } from '@apollo/client';

import { FetchDirections } from '../../queries/index.graphql';
import { createPrefecturesArray } from '../../modules/flight';
import { getPrefectureName, makePostalCodeDisplay } from '../../utils';
import { CHARGE_KIND } from '../../constants';

const CustomerInfoDisplay = ({ customer, representative, isAna2 }) => {
  const { data } = useQuery(FetchDirections);
  const directions = data ? data.directions : [];
  const prefectures = createPrefecturesArray(directions);

  const {
    name, phoneticName, alphabetName, birthday, sex, contact, email,
    postalCode, prefectureID, address1, address2, chargeKind, infantIndicator,
  } = customer;
  const birthdayDisplay = moment(birthday, 'YYYY-MMDD').format('西暦 YYYY年 M月 D日');
  const genderDisplay = sex === 'MALE' ? '男性' : '女性';
  const contactTypeDisplay = contact && contact.type === 'HOME' ? '自宅' : '携帯電話';
  const contactTelDisplay = contact && contact.tel ?
    `${contact.tel.first} - ${contact.tel.second} - ${contact.tel.third}` : '';

  const prefectureName = getPrefectureName(prefectureID, prefectures);

  const isInfant = (chargeKind === CHARGE_KIND.infant) || (!isAna2 && (chargeKind === CHARGE_KIND.children2));
  const isChildren2 = (chargeKind === CHARGE_KIND.children2);
  const infantIndicatorDisplay = (isInfant || (!isAna2 && isChildren2)) ?
    infantIndicator === '1' ? '代表者' : `同行者${Number(infantIndicator) - 1}`
    : undefined;

  return (
    <React.Fragment>
      <div className="userInfoItem">
        <div className="userInfoItemName">お名前</div>
        <div className="userInfoItemDetail">{name.last} {name.first}</div>
      </div>
      {representative && (
        <div className="userInfoItem">
          <div className="userInfoItemName">フリガナ</div>
          <div className="userInfoItemDetail">{phoneticName.last} {phoneticName.first}</div>
        </div>
      )}
      <div className="userInfoItem">
        <div className="userInfoItemName">ローマ字</div>
        <div className="userInfoItemDetail">{alphabetName.last} {alphabetName.first}</div>
      </div>
      <div className="userInfoItem">
        <div className="userInfoItemName">生年月日</div>
        <div className="userInfoItemDetail">{birthdayDisplay}</div>
      </div>
      <div className="userInfoItem">
        <div className="userInfoItemName">性別</div>
        <div className="userInfoItemDetail">{genderDisplay}</div>
      </div>
      {infantIndicatorDisplay && (
        <div className="userInfoItem">
          <div className="userInfoItemName">付添人</div>
          <div className="userInfoItemDetail">{infantIndicatorDisplay}</div>
        </div>
      )}
      {representative && (
        <React.Fragment>
          <div className="userInfoItem">
            <div className="userInfoItemName">日中ご連絡先</div>
            <div className="userInfoItemDetail">{contactTypeDisplay}</div>
          </div>
          <div className="userInfoItem">
            <div className="userInfoItemName">電話番号</div>
            <div className="userInfoItemDetail">{contactTelDisplay}</div>
          </div>
          <div className="userInfoItem">
            <div className="userInfoItemName">郵便番号</div>
            <div className="userInfoItemDetail">{makePostalCodeDisplay(postalCode)}</div>
          </div>
          <div className="userInfoItem">
            <div className="userInfoItemName">住所</div>
            <div className="userInfoItemDetail">{`${prefectureName}${address1}${address2}`}</div>
          </div>
          <div className="userInfoItem">
            <div className="userInfoItemName">メール送付先</div>
            <div className="userInfoItemDetail">{email}</div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

CustomerInfoDisplay.defaultProps = {
  representative: false,
};

CustomerInfoDisplay.propTypes = {
  customer: PropTypes.object.isRequired,
  representative: PropTypes.bool,
};

export default CustomerInfoDisplay;
